import { modalType } from '../../util/ModalUtil';
import { useState, useRef, useEffect } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import { actionEditEnrolmentRegStatusCd } from '../../module/body/semester/SemesterEnrolmentStatusViewTab2BodyModule';
import InputBox from '../../component/InputBox';
import SelectionBox from '../../component/SelectionBox';
import { useDispatch } from 'react-redux';
import StatusTextIconBox from '../../component/StatusTextIconBox';
import PopupRef from '../../component/PopupRef';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const EnrolmentStatusSubjectModal = ({ type, row, modalRef, callback }) => {
    // 변수 선언
    const dispatch = useDispatch();
    const popupRef = useRef(null);
    const [enrolmentRegStatusCd, setEnrolmentRegStatusCd] = useState();

    useEffect(() => {
        row && setEnrolmentRegStatusCd(row.enrolmentRegStatusCd);
    }, []);

    // 취소 버튼
    const handleCancel = () => {
        modalRef.current.close();
    };

    // 확인 버튼
    const handleConfirm = () => {
        if (type === modalType.EDIT) {
            dispatch(
                actionEditEnrolmentRegStatusCd({
                    data: {
                        semesterId: row.semesterId,
                        lessonUniversityCd: row.lessonUniversityCd,
                        subjectId: row.subjectId,
                        classNo: row.classNo,
                        userId: row.userId,
                        universitySubjectId: row.universitySubjectId,
                        enrolmentRegStatusCd,
                        force: true,
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                callback();
                                modalRef.current.close();
                            };
                        });
                    },
                }),
            );
        } else {
            modalRef.current.close();
        }
    };

    // 타이틀 및 안내 메시지 수정
    // 내용 추가
    return (
        <>
            <ModalHeader
                title={type == modalType.EDIT ? '수강신청 정보 수정' : '수강신청 정보 조회'}
                modalRef={modalRef}
            />
            <div className='modal-body'>
                <div className='con-inner EnrolmentStatusSubjectModal'>
                    <InfoTxt
                        infoTxt={type == modalType.EDIT ? '수강신청 정보를 수정합니다.' : '수강신청 정보를 조회합니다.'}
                    />
                    <div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='개설대학'
                                size='medium'
                                disabled
                                value={row && row.lessonUniversityCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                            />
                            <InputBox title='교과목' size='large' disabled value={row && row.subjectNm} />
                            <InputBox title='분반' size='small' disabled value={row && row.classNo} />
                            <InputBox title='교강사' size='medium' disabled value={row && row.profNm} />
                            <InputBox title='학점' size='small' disabled value={row && row.creditCnt} />
                        </div>
                        {/* <div className='form-box-row'>
                            <InputBox
                                title='교과목코드'
                                size='medium'
                                disabled
                                value={row && row.universitySubjectId}
                            />
                        </div> */}
                        <div className='form-box-row'>
                            <SelectionBox
                                title='소속대학'
                                size='medium'
                                disabled
                                value={row && row.userUniversityCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                            />
                            <InputBox title='전공(학과)' size='medium' disabled value={row && row.majorDeptNm} />
                            <InputBox title='소속대학 학번' size='medium' disabled value={row && row.studentId} />
                            <InputBox title='이름' size='medium' disabled value={row && row.userNm} />
                        </div>
                        <div className='form-box-row'>
                            {row.enrolmentRegDttm && (
                                <InputBox
                                    title='수강신청일시'
                                    // size='large'
                                    disabled
                                    value={row && row.enrolmentRegDttm}
                                />
                            )}
                            <SelectionBox
                                title='본교수강자격검증'
                                disabled
                                value={row && row.enrolmentValidStatusCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_VALID_STATUS)}
                                // size='medium'
                            />

                            <InputBox
                                title='개설대학학번'
                                // size='large'
                                disabled
                                value={row && row.lessonUniversityStudentId}
                            />
                        </div>

                        <div className='form-box-row'>
                            <SelectionBox
                                title='수강신청 등록상태'
                                // size='medium'
                                value={enrolmentRegStatusCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_REG_STATUS)}
                                onChange={(e) => setEnrolmentRegStatusCd(e.target.value)}
                                useAll={false}
                                disabled={type == modalType.DETAIL}
                            />
                            {/* {type == modalType.DETAIL ? (
                                <StatusTextIconBox
                                    title='수강신청 등록상태'
                                    size='medium'
                                    codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                                    statusCd={row && row.enrolmentRegStatusCd}
                                />
                            ) : (
                                <SelectionBox
                                    title='수강신청 등록상태'
                                    size='medium'
                                    value={enrolmentRegStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_REG_STATUS)}
                                    onChange={(e) => setEnrolmentRegStatusCd(e.target.value)}
                                    useAll={false}
                                />
                            )} */}
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    {type == modalType.EDIT && <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />}
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default EnrolmentStatusSubjectModal;
